/**
 * Plausible — privacy-friendly, cookieless page analytics.
 *
 * Complements Clarity rather than duplicating it: Plausible answers "how many
 * and from where", Clarity answers "what did they actually do". Neither loads
 * outside production.
 *
 * Like Clarity, this is NOT loaded on the public form renderer (/r/{slug}).
 * Plausible collects no personal data, but a published form's URL is the form
 * owner's business, not ours — and respondents never agreed to be counted by a
 * third party on someone else's behalf. Per-form view counts come from our own
 * `form_counters` table instead.
 */
export const PLAUSIBLE_SCRIPT_URL = "https://plausible.io/js/pa-wGYBzpaVrxtTAHN9DEiBD.js";
/** The upstream bootstrap, verbatim, for inline <script> injection. */
export const plausibleInlineSnippet = () => `window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},` +
    `plausible.init=plausible.init||function(i){plausible.o=i||{}};` +
    `plausible.init()`;
export const initPlausible = ({ enabled = true, scriptUrl = PLAUSIBLE_SCRIPT_URL, } = {}) => {
    if (typeof window === "undefined")
        return;
    if (!enabled) {
        // No-op stub so trackEvent() call sites never need a guard.
        window.plausible ??= (() => { });
        return;
    }
    if (window.plausible?.init)
        return; // already initialised
    const queue = function (...args) {
        (queue.q = queue.q || []).push(args);
    };
    queue.init = (options) => {
        queue.o = options || {};
    };
    window.plausible = queue;
    const script = document.createElement("script");
    script.async = true;
    script.src = scriptUrl;
    document.head.appendChild(script);
    queue.init();
};
/**
 * Custom event. Goals must also exist in the Plausible dashboard to show up.
 *
 * Never pass anything a respondent typed — props land in Plausible's UI.
 */
export const trackEvent = (name, props) => {
    window.plausible?.(name, props ? { props } : undefined);
};
/**
 * Manual pageview, for SPA route changes.
 *
 * The pa-* script hooks the History API on its own, so this is only needed for
 * navigations it cannot see. Wire it into the router in Phase 2 and verify
 * before adding calls — double-counting is the usual failure here.
 */
export const trackPageview = () => {
    window.plausible?.("pageview");
};
//# sourceMappingURL=plausible.js.map